<template>
  <div class="page t-container">
    <div class="page-heading" role="heading">
      <h1 class="page-heading__header">
        Carrier
      </h1>
    </div>

    <div class="tabs-container">
      <nav class="tabs-menu t-space-x-4 md:t-space-x-6">
        <a>
          <router-link :to="{ name: 'carrierConsignments' }" class="link">
            Consignments
          </router-link>
        </a>
        <a>
          <router-link :to="{ name: 'carrierFreightOffers' }" class="t-pb-2">
            Freight Offers
            <span
              class="badge badge-danger t-ml-1"
              v-if="offers.length !== 0"
              >{{ offers.length }}</span
            >
          </router-link>
        </a>
        <a>
          <router-link :to="{ name: 'carrierDifot' }" class="t-pb-2">
            DIFOT Report
          </router-link>
        </a>
        <a>
          <router-link :to="{ name: 'runSheets' }" class="t-pb-2">
            Run Sheets
          </router-link>
        </a>
      </nav>
    </div>

    <router-view :view-compact="viewCompact" v-bind="$attrs"></router-view>
  </div>
</template>

<script>
import FreightOffersTab from "./components/tabs/FreightOffersTab";
import { LOAD_OFFERS } from "../../modules/offers";

export default {
  name: "CarrierPage",
  components: {
    FreightOffersTab
  },
  data() {
    return {
      viewCompact: false,
      pastOffers: []
    };
  },
  computed: {
    offers() {
      return this.$store.getters.offers;
    }
  },
  created() {
    try {
      this.$store.dispatch(LOAD_OFFERS);
    } catch (error) {
      Event.$emit("serverError");
      console.error(error);
    }
  },
  methods: {
    viewChangeHandler() {
      this.viewCompact = !this.viewCompact;
    }
  }
};
</script>

<style scoped></style>
